import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { Leaf } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[80vh] flex items-center pt-16 pb-12 overflow-hidden bg-gradient-to-b from-cream to-warm-deep/30" data-id="element-92">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 opacity-40" data-id="element-93">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-gold/10 blur-3xl" data-id="element-94" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] rounded-full bg-sage/10 blur-3xl" data-id="element-95" />
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-8 w-full" data-id="element-96">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-97">
          {/* Text Content */}
          <div className="max-w-2xl" data-id="element-98">
            <FadeIn delay={0.1} data-id="element-99">
              <div className="flex items-center gap-2 mb-6 text-sage" data-id="element-100">
                <Leaf size={18} className="opacity-80" data-id="element-101" />
                <span className="text-sm font-medium tracking-widest uppercase" data-id="element-102">
                  De Caos a Calma
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-103">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] mb-6 text-brown" data-id="element-104">
                Para la mamá que lo está haciendo sola — <br data-id="element-105" />
                <span className="text-gold italic font-light text-4xl md:text-5xl lg:text-6xl mt-2 block" data-id="element-106">
                  y ya casi no puede más.
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-107">
              <p className="text-xl md:text-2xl text-brown/80 leading-relaxed mb-10 border-l-4 border-gold/30 pl-6 py-2" data-id="element-108">
                Sin red de apoyo. Sin descanso. Con TDAH y Sin nadie que
                sostenga de ti.
                <span className="block mt-2 font-medium text-brown-light" data-id="element-109">
                  Este ebook de 30 días fue escrito para ti.
                </span>
              </p>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-110">
              <div className="flex flex-col sm:flex-row items-center gap-4" data-id="element-111">
                <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
                behavior: 'smooth'
              })} className="bg-gold hover:bg-gold-dark text-white px-8 py-4 rounded-full text-lg font-bold transition-all duration-300 shadow-lg shadow-gold/20 hover:shadow-xl hover:shadow-gold/30 hover:-translate-y-1 w-full sm:w-auto flex items-center justify-center gap-2" data-id="element-112">
                  👉 SÍ, QUIERO MI CALMA →
                </button>
              </div>
              <p className="text-sm text-brown-light/70 mt-4 font-medium text-center sm:text-left ml-2" data-id="element-113">
                Acceso inmediato • Descarga instantánea
              </p>
            </FadeIn>
          </div>

          {/* Image Content */}
          <FadeIn delay={0.4} direction="left" className="relative lg:h-[500px] flex justify-center items-center" data-id="element-114">
            <motion.div className="relative w-full max-w-md lg:max-w-full" animate={{
            y: [0, -15, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-115">
              {/* Decorative glow behind image */}
              <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full scale-90 -z-10" data-id="element-116" />

              <img src="https://cdn.magicpatterns.com/uploads/kTZunzwuinmXipaYdS7Wve/arte_landin_formato_web.webp" alt="De Caos a Calma - Bundle de productos digitales" className="w-full h-auto object-contain drop-shadow-2xl lg:max-h-[480px]" data-id="element-117" />
            </motion.div>
          </FadeIn>
        </div>
      </div>
    </section>;
}